import Axios from 'axios'
import { URLS } from './constants'

const BASE_URL = `${URLS.URL_PRD}/purchase-order`

const pickingStateAPI = {
  getOCS: async (currentPage = 1, perPage = 10, filters = {}) => {
    const { purchaseDate, compromiseDate, journeys, textSearch, stores } =
      filters;
    console.log(filters, "FIILTERSSS");
    const { data } = await Axios.get(BASE_URL, {
      params: {
        currentPage,
        perPage,
        textSearch,
        ...(purchaseDate && { purchaseDate }),
        ...(compromiseDate && { compromiseDate }),
        ...(journeys.length > 0 && {
          journeys: journeys.map((j) => j?.code).join(","),
        }),
        ...(stores.length > 0 && {
          stores: stores.map((s) => s?.id).join(","),
        }),
      },
    });
    return data;
  },

  getOCDetail: async (orderNumber, storeId) => {
    const { data } = await Axios.get(`${BASE_URL}/${orderNumber}`, {
      params: {
        storeId,
      },
    });
    return data.purchaseOrder;
  },

  exportExcelOC: async (purchaseOrders) => {
    const { data } = await Axios({
      method: 'POST',
      url: `${URLS.URL_PRD}/excel/states-report`,
      data: { purchaseOrders },
      responseType: "blob",
    });
    return data;
  },

  exportExcelTotalOC: async (type, dateFrom, dateTo) => {
    const { data } = await Axios({
      method: 'POST',
      url: `${URLS.URL_PRD}/excel/states-report-total`,
      data: {
        type,
        dateFrom,
        dateTo,
      },
      responseType: "blob",
    });
    return data;
  },

  sendEmailExcelOC: async (purchaseOrders, email) => {
    const { data } = await Axios({
      method: 'POST',
      url: `${URLS.URL_PRD}/excel/states-report/email`,
      data: { purchaseOrders, email },
    });
    return data;
  },
};

export default pickingStateAPI
